export const API = process.env.REACT_APP_API_URL ?? '';

export const BACKEND = process.env.REACT_APP_BACKEND_URL ?? '';

export const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST ?? '';

export const ADMIN_IMAGES_URL = process.env.REACT_APP_ADMIN_IMAGES_URL ?? '';